import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const clientToken = secureStorage.getItem("clientToken");

export const getHotels = (setHotelData, setIsLoading, id) => {
  setIsLoading(true);
  axiosInstance
    .get(`/client/stayover/hotels/${id}`, {
      headers: {
        Authorization: `Bearer ${clientToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setHotelData(res.data.data);

      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getRooms = (setRoomData, setIsLoading, SelectedHotels, id) => {
  setIsLoading(true);
  axiosInstance
    .get(`/client/stayover/rooms/${id}/${SelectedHotels}`, {
      headers: {
        Authorization: `Bearer ${clientToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setRoomData(res.data.data);

      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const sendStayoverRequest = (FormData, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post(`/client/stayover/add`, FormData, {
      headers: {
        Authorization: `Bearer ${clientToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Stayover requested successfully") {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
